import { FC, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {FlowType} from "../../constants/flowType";
import {usePaymentFlow} from "../../hooks/usePaymentFlow";
import {selectorOrder, setFlowSize, setFlowType} from "../../slices/OrderSlice";
import {StepItem, StepManager} from "../../components/StepManager/StepManager";

interface PaymentManagerProps {
  flowType: FlowType
  onNotEnoughMoney?: () => void
  onPaymentFail?: () => void
  onPaymentSuccess?: () => void
  sharedProps?: any // пропсы для всех компонентов на всех этапах степпера
}

export const PaymentManager: FC<PaymentManagerProps> = ({flowType, onPaymentFail, onPaymentSuccess, onNotEnoughMoney, sharedProps}) => {
  const {currentFlow} = usePaymentFlow(flowType)
  const {flowStep} = useSelector(selectorOrder)
  const dispatch = useDispatch()

  useEffect(() => () => {
    // dispatch(setFlowType(null)) припополнении баланса в некоторых flow закрывается эта модалка и открывается пополнение, при этом тип теряется
    //TODO - пополнение включить во flow
  }, [])

  useEffect(() => {
    dispatch(setFlowType(flowType))
  }, [flowType])


  useEffect(() => {
    dispatch(setFlowSize(currentFlow?.length || 0))
  }, [currentFlow])

  const config = useMemo(() => {
    return currentFlow ? currentFlow?.map(({component, props}, index) => {
      return {
        props: {...props, onPaymentFail, onPaymentSuccess, onNotEnoughMoney, ...sharedProps},
        component,
        step: index+1
      } as StepItem
    }) : []
  }, [currentFlow])

  return (
    <StepManager
      config={config}
      defaultStep={flowStep}
    />
  )
}
import { FC, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {FlowType} from "../../constants/flowType";
import {usePaymentFlow} from "../../hooks/usePaymentFlow";
import {selectorOrder, setFlowSize, setFlowType} from "../../slices/OrderSlice";
import {StepItem, StepManager} from "../../components/StepManager/StepManager";

interface PaymentManagerProps {
  flowType: FlowType
  onNotEnoughMoney?: () => void
  onPaymentFail?: () => void
  onPaymentSuccess?: () => void
  sharedProps?: any // пропсы для всех компонентов на всех этапах степпера
}

export const PaymentManager: FC<PaymentManagerProps> = ({flowType, onPaymentFail, onPaymentSuccess, onNotEnoughMoney, sharedProps}) => {
  const {currentFlow} = usePaymentFlow(flowType)
  const {flowStep} = useSelector(selectorOrder)
  const dispatch = useDispatch()

  useEffect(() => () => {
    // dispatch(setFlowType(null)) припополнении баланса в некоторых flow закрывается эта модалка и открывается пополнение, при этом тип теряется
    //TODO - пополнение включить во flow
  }, [])

  useEffect(() => {
    dispatch(setFlowType(flowType))
  }, [flowType])


  useEffect(() => {
    dispatch(setFlowSize(currentFlow?.length || 0))
  }, [currentFlow])

  const config = useMemo(() => {
    return currentFlow ? currentFlow?.map(({component, props}, index) => {
      return {
        props: {...props, onPaymentFail, onPaymentSuccess, onNotEnoughMoney, ...sharedProps},
        component,
        step: index+1
      } as StepItem
    }) : []
  }, [currentFlow])

  return (
    <StepManager
      config={config}
      defaultStep={flowStep}
    />
  )
}
